module.exports = __webpack_public_path__ + "images/a49d61bbf53fd714f90808a8ff26ed08-favicon-32x32.png";